import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'
import { SourcingRoute } from '@/components/pages/companies/reducers/sourcingAnnotationCandidates'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { StatusPanelSection } from './StatusPanelSection'
import { SourcingRouteDropdown } from '@/components/pages/companies/components/tableCell/SourcingRouteDropdown'
import { useRef, useState } from 'react'
import { User } from 'types'
import { useUser } from '@/contexts/AuthContext'
import {
  SOURCING_ROUTE_SETTING_ON_STATUS_PANEL,
  trackEvent,
} from '@/lib/tracking'
import { useOnClickOutside } from '@/hooks/useOnClickOutside'

type SourcingRouteSectionProps = {
  shortname: string
  selectedSourcingRouteId?: number
  sourcingRoutes: SourcingRoute[]
  onSelectSourcingRoute: (
    companyId: string,
    sourcingRouteId: number,
    souringRouteName: string,
    user: User
  ) => void
  onDeselectSourcingRoute: () => void
  onRequestEditSourcingRouteModal: () => void
}

export const SourcingRouteSection: React.FC<SourcingRouteSectionProps> = ({
  shortname,
  selectedSourcingRouteId,
  sourcingRoutes,
  onSelectSourcingRoute,
  onDeselectSourcingRoute,
  onRequestEditSourcingRouteModal,
}) => {
  const user = useUser()
  const [dropdownOpening, setDropdownOpening] = useState(false)

  const wrapperRef = useRef<HTMLDivElement>(null)
  useOnClickOutside([wrapperRef], () => {
    setDropdownOpening(false)
  })

  const handleSelectSourcingRoute = (
    sourcingRouteId: number,
    sourcingRouteName: string
  ) => {
    onSelectSourcingRoute(shortname, sourcingRouteId, sourcingRouteName, user)
    trackEvent(user, SOURCING_ROUTE_SETTING_ON_STATUS_PANEL)
  }

  const handleDeselectSourcingRoute = () => {
    onDeselectSourcingRoute()
    trackEvent(user, SOURCING_ROUTE_SETTING_ON_STATUS_PANEL)
  }

  const selectedSourcingRoute = sourcingRoutes.find(
    (it) => it.id === selectedSourcingRouteId
  )
  return (
    <StatusPanelSection label="ソーシングルート">
      <div
        css={css`
          position: relative;
        `}
        ref={wrapperRef}
      >
        <button
          css={css`
            border: none;
            display: flex;
            align-items: center;
            padding: 7px 4px 7px 10px;
            gap: 4px;
            border-radius: 3px;
            cursor: pointer;
            background-color: ${dropdownOpening
              ? colors.gray40
              : 'transparent'};
            &:hover {
              background-color: ${colors.gray40};
            }
            position: relative;
          `}
          onClick={() => {
            setDropdownOpening(!dropdownOpening)
          }}
          data-test-id="sourcing-route"
        >
          <div
            css={css`
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: ${font.weight.normal};
              font-size: 14px;
              color: ${selectedSourcingRoute ? colors.black30 : colors.gray70};
            `}
          >
            {selectedSourcingRoute ? selectedSourcingRoute.name : '（空白）'}
          </div>
          <IcomoonIcon
            name="arrow1s-down"
            css={css`
              color: ${colors.black30};
              font-size: 20px;
            `}
          />
        </button>
        {dropdownOpening && (
          <SourcingRouteDropdown
            sourcingRoutes={sourcingRoutes}
            selectedSourcingRouteId={selectedSourcingRouteId}
            onSelectSourcingRoute={handleSelectSourcingRoute}
            onDeselectSourcingRoute={handleDeselectSourcingRoute}
            onRequestEditSourcingRouteModal={onRequestEditSourcingRouteModal}
          />
        )}
      </div>
    </StatusPanelSection>
  )
}
